<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="delete-confirm-view">
    <div class="delete-wrap">
      <div class="delete-head">
        <div class="icon-ajuntament" />
      </div>
      <h2>{{ $t('delete_user_confirm') }}</h2>
      <p class="delete-desc">{{ $t('delete_thanks') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      emailInput: '',
    }
  },
  computed: {},
  watch: {},
  methods: {
    /**
     * Update the current route with new params if current page is different
     * @param {String} routeName Name of page that user want's to navigate
     * @public This is a public method
     */
    routeChange(routeName) {
      if (this.$route.name !== routeName) this.$router.push({ name: routeName })
    },
  },
}
</script>

<style lang="stylus" scoped>
.delete-confirm-view
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  min-height: "calc(100vh - %s - %s - %s)" % ($header-height $subheader-height $footer-height)
  background-color: rgba($bcn-dark-blue-gray, 0.05)

  .delete-wrap
    display: flex
    flex-direction: column
    align-items: center
    padding: vw(20px)
    min-width: 250px
    width: 60%
    border-radius: 8px
    background-color: #fff
    box-shadow: 0 4px 80px rgba(0, 0, 0, 0.05)
    gap: vw(5px)

    .delete-head
      display: flex
      justify-content: space-between
      width: 100%

      .icon-ajuntament
        width: vw(176px)
        height: vw(45px)
        background-image: url("~@/assets/logos/logo-ajuntament-barcelona-rounded.svg")
        background-position: center center
        background-size: cover
        background-repeat: no-repeat

    h2
      margin-block-start: 1.5em
      font-size(32, 44)
      font-weight: 600

    .delete-desc
      display: flex
      justify-content: center
      font-size(20, 24)
      margin-bottom: vw(20px)
      width: 85%
      font-weight: 400
</style>